export const Preview = 'preview'

export const File = 'file'
